import { JSX, Show } from 'solid-js';

type SectionCardProps = {
  title: string | JSX.Element;
  startIcon?: JSX.Element;
  endIcon?: JSX.Element | boolean;
  children: JSX.Element | string;
  class?: string;
  contentClass?: string;
};

const SectionCard = (sectionCardProps: SectionCardProps) => {
  return (
    <div
      class={`mb-3 border border-[#026ea1] rounded-md shadow-lg bg-[#026ea1] w-full ${sectionCardProps.class ?? ''}`}
    >
      <div class="font-semibold text-white p-2 relative rounded-t-md flex items-center">
        <Show when={sectionCardProps.startIcon}>
          <span class="pr-2 shrink-0">{sectionCardProps.startIcon}</span>
        </Show>
        <div class="truncate flex-1 min-w-0">{sectionCardProps.title}</div>
        <Show when={sectionCardProps.endIcon}>
          <span class="ml-2 shrink-0">{sectionCardProps.endIcon}</span>
        </Show>
      </div>
      <div class={`bg-white! rounded-b-md ${sectionCardProps.contentClass}`}>
        {sectionCardProps.children}
      </div>
    </div>
  );
};

export default SectionCard;
